import { getThumbmark as w } from "@thumbmarkjs/thumbmarkjs";
import { openDB as f } from "idb";
import { createAnalyticsEmitter as b } from "./client.js";
const i = (e) => e?.trim() ? e.trim() : void 0, u = (e) => e?.length ? [...e] : void 0, m = (e) => typeof e == "number" && Number.isFinite(e) ? e : void 0, g = (e) => {
  const t = m(e);
  return t === void 0 ? void 0 : Math.round(t);
}, o = (e) => {
  const t = Object.entries(e).filter(([, r]) => r !== void 0);
  return t.length > 0 ? Object.fromEntries(t) : void 0;
}, a = (e) => o(e) ?? {}, l = async (e) => {
  try {
    return await e();
  } catch {
    return {};
  }
}, h = () => ({ network: { status: navigator.onLine ? "online" : "offline" } }), y = () => a({ browser: o({ userAgent: i(navigator.userAgent) }) }), p = () => {
  const e = m(navigator.deviceMemory);
  return a({
    hardware: o({
      cpu: o({ logicalCores: m(navigator.hardwareConcurrency) }),
      memory: e === void 0 ? void 0 : { totalBytes: e * 1024 ** 3 }
    })
  });
}, E = async () => {
  const e = await navigator.userAgentData.getHighEntropyValues([
    "architecture",
    "bitness",
    "formFactors",
    "fullVersionList",
    "model",
    "platformVersion"
  ]);
  return a({
    device: o({
      architecture: i(e.architecture),
      bitness: i(e.bitness),
      formFactors: u(e.formFactors),
      mobile: e.mobile,
      model: i(e.model)
    }),
    os: o({ name: i(e.platform), version: i(e.platformVersion) }),
    browser: o({ brands: u(e.brands), fullVersionList: u(e.fullVersionList) }),
    hardware: o({ cpu: o({ architecture: i(e.architecture) }) })
  });
}, A = async () => {
  const e = await navigator.getBattery(), t = m(e.level);
  return a({
    hardware: o({
      battery: o({
        chargePercent: t === void 0 ? void 0 : t * 100,
        isCharging: e.charging,
        chargingTimeSeconds: g(e.chargingTime),
        dischargingTimeSeconds: g(e.dischargingTime)
      })
    })
  });
}, F = 2e3, T = async (e) => {
  const { thumbmark: t, components: r } = await w({ timeout: e, logging: !1 }), n = r.system;
  return a({
    browser: o({
      fingerprint: i(t),
      name: i(n?.browser?.name),
      version: i(n?.browser?.version)
    })
  });
}, M = async (e = {}) => {
  const [t, r, n] = await Promise.all([
    l(E),
    l(A),
    l(() => T(e.fingerprintTimeoutMs ?? F))
  ]), s = p().hardware;
  return a({
    device: t.device,
    os: t.os,
    browser: o({ ...y().browser, ...t.browser, ...n.browser }),
    hardware: o({
      ...s,
      ...r.hardware,
      cpu: o({ ...s?.cpu, ...t.hardware?.cpu })
    })
  });
}, O = (e) => ({ app: e, network: h().network }), L = "verity-analytics", c = "queue", k = (e = L) => {
  let t;
  const r = () => t ??= f(e, 1, {
    upgrade(n) {
      n.createObjectStore(c, { keyPath: "event.eventUuid" }).createIndex("byEnqueuedAt", "enqueuedAt");
    }
  });
  return {
    put: async (n) => {
      const s = (await r()).transaction(c, "readwrite");
      for (const d of n) s.store.put(d);
      await s.done;
    },
    due: async (n, s) => (await (await r()).getAllFromIndex(c, "byEnqueuedAt")).filter((v) => v.nextAttemptAt <= n).slice(0, s),
    remove: async (n) => {
      const s = (await r()).transaction(c, "readwrite");
      for (const d of n) s.store.delete(d);
      await s.done;
    },
    size: async () => (await r()).count(c)
  };
}, _ = (e, t = {}) => {
  const r = b(e, {
    queueStore: k(),
    emissionEnabled: navigator.onLine,
    ...t
  }), n = () => r.setEmissionEnabled(!0), s = () => r.setEmissionEnabled(!1);
  return addEventListener("online", n), addEventListener("offline", s), r.flush(), {
    ...r,
    close: () => {
      removeEventListener("online", n), removeEventListener("offline", s), r.close();
    }
  };
};
export {
  F as DEFAULT_FINGERPRINT_TIMEOUT_MS,
  M as collectDeviceContext,
  _ as createBrowserAnalyticsEmitter,
  k as createIdbQueueStore,
  O as liveContext
};
//# sourceMappingURL=browser.js.map
